import React from "react";
import Reveal from "./Reveal";
import { ArrowUpRight } from "lucide-react";

const posts = [
  {
    date: "Nov 14, 2025",
    title: "They finally stopped making copper pennies.",
    excerpt:
      "In November 2025, the U.S. Treasury struck its final penny after more than 230 years of production. My barrels of copper pennies just became a finite resource. I've been waiting for this moment.",
    href: "https://ryanbest.com/they-finally-stopped-making-copper-pennies/",
    tag: "Economics",
  },
  {
    date: "Sep 7, 2025",
    title: "The five-second AI detection myth.",
    excerpt:
      "An influencer confidently declared she could spot AI-generated responses within five seconds. I thought she was absolutely right — and entirely wrong. Here's why.",
    href: "https://ryanbest.com/the-five-second-ai-detection-myth/",
    tag: "AI",
  },
  {
    date: "Aug 8, 2025",
    title: "Why gold vs. crypto misses everything.",
    excerpt:
      "Gold sitting in a safe is dead capital. I learned this running a mint for years — watching precious metals appreciate while remaining completely unusable. Here's the real conversation.",
    href: "https://ryanbest.com/why-gold-versus-crypto-misses-everything/",
    tag: "Investing",
  },
];

export const Writing = () => {
  return (
    <section
      id="writing"
      data-testid="writing-section"
      className="relative py-28 lg:py-40 border-t border-gold-deep/40 z-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16 lg:mb-24">
            <div>
              <div className="overline mb-6">Writing · Field Notes</div>
              <h2 className="heading-section text-5xl lg:text-7xl text-white max-w-3xl">
                Thinking out <span className="italic gold-gradient-text">loud.</span>
              </h2>
            </div>
            <a
              href="https://ryanbest.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/60 hover:text-gold transition-colors"
              data-testid="writing-all-link"
            >
              Read the full archive →
            </a>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-3 gap-5">
          {posts.map((post, idx) => (
            <Reveal key={post.title} delay={idx * 120}>
              <a
                href={post.href}
                target="_blank"
                rel="noopener noreferrer"
                className="card-luxe group block p-8 lg:p-10 h-full flex flex-col"
                data-testid={`post-${idx}`}
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold/80">
                    {post.tag}
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
                    {post.date}
                  </span>
                </div>
                <h3 className="heading-section text-2xl lg:text-3xl text-white mb-4 group-hover:text-gold-light transition-colors duration-500">
                  {post.title}
                </h3>
                <p className="body-copy text-sm text-white/60 flex-1">{post.excerpt}</p>
                <div className="mt-8 flex items-center justify-between pt-6 border-t border-gold-deep/50">
                  <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold">
                    Read essay
                  </span>
                  <ArrowUpRight className="w-4 h-4 text-gold/70 group-hover:text-gold group-hover:rotate-45 transition-all duration-500" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Writing;
